import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { MyButton } from "../../components/MyButton";
import { MyNoiseGradadientBackground } from "../../components/backgrounds";

export const NotFoundPage = () => {
  const navigate = useNavigate();
  return (
    <Container
      fluid
      className="vh-100  w-75 d-flex flex-column justify-content-center align-items-center"
    >
      <MyNoiseGradadientBackground />
      <Row className="text-center justify-content-center align-items-center h-100 ">
        <Col
          className="text-center justify-content-center align-items-center"
          style={{
            maxWidth: "20rem",
          }}
        >
          <h1 style={{ fontSize: "5rem" }} className="text-light fw-bold my-5">
            Ooops!
          </h1>
          <h5 className="text-light my-5">
            Non abbiamo trovato quello che stavi cercando...
          </h5>

          <MyButton
            variant="light"
            className="text-light my-5 w-100"
            onClick={() => navigate("/")}
          >
            <strong>Torna alla Home</strong>
          </MyButton>
        </Col>
      </Row>
    </Container>
  );
};
